var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('safe-img',{staticClass:"avatar",style:(_vm.size?("width:" + _vm.size + "px; height:" + _vm.size + "px"):''),attrs:{"src":_vm.computedLogo,"placeholder":_vm.avatarPlaceholder}})}
var staticRenderFns = []

export { render, staticRenderFns }